module.exports = __webpack_public_path__ + "img/ico_badge13.00e29b15.svg";